import { root } from 'elc-universal-utils';
import { ServiceManifest } from './manifest';
//@ts-ignore
root.ServiceRegistry['elc-service-communications'] = ServiceManifest;
